/* Admin 管理员信息 */

export default {
  namespaced: true,

  state: {
    // 商家管理员信息
    merchantInfo: [],
  },

  mutations: {
    /**
     * 设置商家管理员信息
     * @param {*} state
     * @param {*} merchantInfo
     */
    setMerchantInfo(state, merchantInfo) {
      state.merchantInfo = merchantInfo;
    },
  },
};
